//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimeField from '../fields/TimeField.vue'
import CheckboxField from '../fields/CheckboxField.vue'
import SelectField from '../fields/SelectField.vue';
import InputField from '../fields/InputField.vue';
import moment from 'moment';
import axios from 'axios';
export default {
  components: {
    TimeField,
    CheckboxField,
    SelectField,
    InputField,
  },
  props: {
    date: String,
    expert: String,
    type: String,
    ajax: String,
    sessions: Array | null,
  },
  data: function(){
    return {
      // amount_selectors: [],
      session: {
        value: '',
        error: '',
      },
      start: {
        value: '00:00',
        error: '',
      },
      end: {
        value: '00:00',
        error: '',
      },
      repeat: {
        value: false,
        error: '',
      },
      amount: {
        value: 1,
        error: '',
      },
      interval: {
        value: {
          label: 'Dag(en)',
          code: 'day',
        },
        error: '',
      },
      monday: {
        value: false,
      },
      tuesday: {
        value: false,
      },
      wednesday: {
        value: false,
      },
      thursday: {
        value: false,
      },
      friday: {
        value: false,
      },
      saturday: {
        value: false,
      },
      sunday: {
        value: false,
      },
      end_repeat: {
        value: moment(this.data).add(3, 'M').format('YYYY-MM-DD'),
        error: '',
      },
    };
  },
  methods: {
    handleSave: function(){
      const formData = new FormData();
      formData.append('date', this.date);
      formData.append('expert', this.expert);
      formData.append('type', this.type);
      formData.append('session', this.session.value.code);
      formData.append('start', this.start.value);
      formData.append('end', this.end.value);
      formData.append('repeat', this.repeat.value);
      formData.append('amount', this.amount.value);
      formData.append('interval', this.interval.value.code);
      formData.append('monday', this.monday.value);
      formData.append('tuesday', this.tuesday.value);
      formData.append('wednesday', this.wednesday.value);
      formData.append('thursday', this.thursday.value);
      formData.append('friday', this.friday.value);
      formData.append('saturday', this.saturday.value);
      formData.append('sunday', this.sunday.value);
      formData.append('end_repeat', this.end_repeat.value);
      axios({
        method: 'post',
        url: `${this.ajax}?action=store_availabilities`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(() => {
        this.$parent.handleSuccess();
        this.$parent.handleClose();
        this.$parent.success = true;
        this.$parent.openNewGroepDate = false;
        this.$parent.openNewOpenDate = false;
      }).catch(() => {
        console.log('error');
      });
    },
    handleClose: function(){
      this.$parent.handleClose();
    },
    messageAddDay: function(){
      let text = [];
      if(this.monday.value){
        text.push('maandag');
      }
      if(this.tuesday.value){
        text.push('dinsdag');
      }
      if(this.wednesday.value){
        text.push('woensdag');
      }
      if(this.thursday.value){
        text.push('donderdag');
      }
      if(this.friday.value){
        text.push('vrijdag');
      }
      if(this.saturday.value){
        text.push('zaterdag');
      }
      if(this.sunday.value){
        text.push('zonday');
      }
      return text.join(', ');
    },
    message: function(){
      let text = [];
      if(this.interval.value.code === 'day'){
        if (parseInt(this.amount.value) === 1) {
          text.push('op elke dag');
        } else if(parseInt(this.amount.value) === 2) {
          text.push('om de dag');
        } else {
          text.push(`op elke ${this.amount.value} dagen`);
        }
      }
      if(this.interval.value.code === 'week'){
        const days = this.messageAddDay();
        if (parseInt(this.amount.value) === 1) {
          text.push(`op elke ${days}`);
        } else if(parseInt(this.amount.value) === 2) {
          text.push('om de week');
          text.push(`op ${days}`);
        } else {
          text.push(`op elke ${this.amount.value} weken`);
          text.push(`op ${days}`);
        }
      }
      return text.join(' ');
    },
  },
  mounted: function(){
    // let amount_selectors = [];
    // for (let index = 1; index <= 99; index++) {
    //   amount_selectors.push({
    //     label: `${index}`,
    //     code: `${index}`,
    //   });
    // }
    // this.amount_selectors = amount_selectors;
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Agenda/NewDate.vue